import React from 'react';
import { Modal } from 'react-bootstrap';

class Details extends React.Component<any, any> {

    render() {
        const { body } = this.props;
        return (
            <Modal
                centered
                size="xl"
                backdrop="static"
                onHide={this.props.onClose}
                show={this.props.show}
                style={{ zIndex: 1201 }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Message
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
                    <div>
                        <h2>Body</h2>
                        <div dangerouslySetInnerHTML={{ __html: body || '' }} />
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default Details;
